var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table__container", style: _vm.tableStyle }, [
    _c(
      "table",
      [
        _c("thead", [
          _c(
            "tr",
            [
              _vm.config.hasCheckbox
                ? _c(
                    "th",
                    { attrs: { width: "4%" } },
                    [
                      _c("Checkbox", {
                        staticClass: "th__items__container",
                        attrs: { name: "all", id: "all" },
                        on: {
                          handleCheck: function($event) {
                            return _vm.checked("all")
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.config.columns, function(col, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    attrs: { width: col.width },
                    on: {
                      click: function($event) {
                        return _vm.sortItem(col.key)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "th__items__container" }, [
                      _c(
                        "div",
                        [
                          col.icon && col.icon.before
                            ? _c("Icon", {
                                attrs: {
                                  icon: col.icon.before,
                                  width: 21,
                                  height: 22,
                                  color: "#4e68b0"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "col__name" }, [
                            _vm._v(_vm._s(col.name) + " ")
                          ])
                        ],
                        1
                      ),
                      col.icon && col.icon.after
                        ? _c(
                            "span",
                            {
                              staticClass: "icon__after",
                              on: {
                                click: function($event) {
                                  return _vm.$emit("iconClicked", col.key)
                                }
                              }
                            },
                            [
                              _c("Icon", {
                                attrs: {
                                  icon: col.icon.after,
                                  color: "#4e68b0",
                                  width: 29,
                                  height: 21
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("span", { staticClass: "sort__arrows" }, [
                        _c("i", {
                          staticClass: "fas fa-angle-up",
                          style: {
                            color:
                              _vm.sortby == col.key && _vm.sort == "asc"
                                ? "#4e68b0"
                                : "#d5d4d4"
                          }
                        }),
                        _c("i", {
                          staticClass: "fas fa-angle-down",
                          style: {
                            color:
                              _vm.sortby == col.key && _vm.sort == "desc"
                                ? "#4e68b0"
                                : "#d5d4d4"
                          }
                        })
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.config.actions &&
              _vm.config.actions.elements &&
              _vm.config.actions.elements.length != 0
                ? _c("th", { attrs: { width: _vm.config.actions.width } }, [
                    _c("div", { staticClass: "th__items__container" }, [
                      _vm._v(_vm._s(_vm.config.actions.name))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.data, function(item, itemIndex) {
          return _c(
            "tr",
            { key: itemIndex, staticClass: "tbody" },
            [
              _vm.config.hasCheckbox
                ? _c(
                    "td",
                    [
                      _c("Checkbox", {
                        staticClass: "checkbox__container",
                        attrs: {
                          name: item.name,
                          id: item.id,
                          check:
                            _vm.checkAll ||
                            _vm.selectedProjects.includes(item.id)
                        },
                        on: {
                          handleCheck: function($event) {
                            return _vm.checked(item.id)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.config.columns, function(col, colIndex) {
                return _c(
                  "td",
                  {
                    key: colIndex,
                    staticClass: "tab__elements",
                    on: {
                      click: function($event) {
                        return _vm.selected(item, _vm.config.action)
                      }
                    }
                  },
                  [
                    col.type
                      ? _c(
                          "div",
                          {
                            on: {
                              click: function($event) {
                                return _vm.$emit(
                                  "selectMedia",
                                  item.id,
                                  col.type,
                                  col.key,
                                  item
                                )
                              }
                            }
                          },
                          [
                            _c(col.component, {
                              tag: "components",
                              attrs: {
                                type: col.type,
                                poster: col.poster ? col.poster : null,
                                color: col.color ? col.color : "#fff",
                                item: Object.assign({}, item[col.key], {
                                  _id: item.id
                                }),
                                activeMedia: _vm.activeMedia
                              },
                              on: { play: _vm.playedMedia }
                            })
                          ],
                          1
                        )
                      : _c("div", [
                          _vm._v(_vm._s(item[col.key] ? item[col.key] : "N/A"))
                        ])
                  ]
                )
              }),
              _vm._v(" "),
              _vm.config.actions &&
              _vm.config.actions.elements &&
              _vm.config.actions.elements.length != 0
                ? _c("td", { staticClass: "tab__actions" }, [
                    _c(
                      "div",
                      { staticClass: "actions__container" },
                      [
                        _vm.config.actions.hasSimpleList
                          ? _c(
                              "div",
                              { staticClass: "actions__elements" },
                              [
                                _vm._l(_vm.config.actions.elements, function(
                                  action,
                                  actionIndex
                                ) {
                                  return [
                                    action.icon
                                      ? _c("span", {
                                          key: actionIndex,
                                          style: "color : " + action.color,
                                          domProps: {
                                            innerHTML: _vm._s(action.icon)
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.selected(
                                                item,
                                                action.action
                                              )
                                            }
                                          }
                                        })
                                      : _c(
                                          "Button",
                                          _vm._b(
                                            {
                                              key: actionIndex,
                                              on: {
                                                click: function($event) {
                                                  return _vm.selected(
                                                    item,
                                                    action.action
                                                  )
                                                }
                                              }
                                            },
                                            "Button",
                                            _vm.buttonConfig,
                                            false
                                          ),
                                          [_vm._v(_vm._s(action.name))]
                                        )
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.config.actions.hasToggleList
                          ? _c("Icon", {
                              staticClass: "list__icon",
                              class: {
                                active__list: itemIndex == _vm.activeAction
                              },
                              attrs: {
                                icon: "list",
                                color: "gray",
                                width: 20,
                                height: 20
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showActionList(itemIndex)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.activeAction == itemIndex &&
                        _vm.config.actions.hasToggleList
                          ? _c(
                              "div",
                              { staticClass: "actions__bloc" },
                              [
                                _c("GalleryActions", {
                                  attrs: {
                                    actions: _vm.config.actions.list,
                                    story: item
                                  },
                                  on: {
                                    clicked: function($event) {
                                      return _vm.toggleActions(itemIndex, item)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06b1ed52", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06b1ed52","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Table.vue
// module id = null
// module chunks = 